module.exports = __webpack_public_path__ + "static/img/cLbtu12.f72c158e.jpg";